<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="study-search-tab">
	<div class="d-flex">
		<jhi-column-filter [request]="request" [resultSearch]="resultSearch" [filters]="filters" [eventName]="COLUMN_FILTER_EVENT_NAME"
						   class="flex-sm-grow-1"></jhi-column-filter>
	</div>
	<br/>
	<div class="row">
		<div class="col">
			<div class="mb-3 d-flex align-items-center">
				<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
				<div style="margin-left: 10px;">
					<a href (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></a>
				</div>
				<span *ngIf="isLoading" style="margin-left: 10px;" class="throbber"></span>
			</div>
		</div>
	</div>
	<br/>
	<div class="table-responsive" *ngIf="studies">
		<table class="table table-striped table-bordered table-curved" *ngIf="studies.length else nodata" data-test="studySearchTable">
			<thead>
			<tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="transition.bind(this)">
				<th [jhiSortBy]="ColumnLabels.STUDY_NAME" style="width: 250px"><span jhiTranslate="study.manager.search.columns.study-name"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.STUDY_TYPE_NAME" style="width: 95px"><span jhiTranslate="study.manager.search.columns.study-type"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.LOCKED" style="width: 75px"><span jhiTranslate="study.manager.search.columns.locked"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.STUDY_OWNER_NAME"><span jhiTranslate="study.manager.search.columns.created-by"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.START_DATE" style="width: 80px"><span jhiTranslate="study.manager.search.columns.date"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.PARENT_FOLDER_NAME"><span jhiTranslate="study.manager.search.columns.parent-folder"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.OBJECTIVE" style="width: 250px"><span jhiTranslate="study.manager.search.columns.objective"></span> <span class="fa fa-sort"></span></th>
				<th style="width: 80px"><span jhiTranslate="study.manager.search.columns.actions"></span></th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let study of studies; trackBy: trackId; index as index">
				<td><a href (click)="openViewSummary($event, study)" class="text-wrap"><truncate-span [textInput]="study.studyName" [maxLength]="255" [showCopyButton]="true"></truncate-span></a></td>
				<td>{{ getStudyType(study.studyTypeName) | translate}}</td>
				<td>{{study.locked ? 'Yes' : 'No'}}</td>
				<td>{{study.ownerName}}</td>
				<td>{{study.startDate}}</td>
				<td>{{study.parentFolderName}}</td>
				<td><truncate-span [textInput]="study.objective" [maxLength]="50"></truncate-span></td>
				<td class="text-center" >
                    <button class="btn btn-outline-info btn-sm" (click)="openStudyNew(study)" *jhiHasAnyAuthority="STUDIES_EDITION_PERMISSIONS" [hidden]="!this.study.program_uuid">
                        <i class="fa fa-edit fa-md" aria-hidden="true"></i>
                    </button>
				</td>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td jhiTranslate="no.data"></td>
				</tr>
				</tbody>
			</table>
		</ng-template>
	</div>
	<div *ngIf="studies && studies.length">
		<div class="row">
			<div class="col">
				<div class="pagination-container">
					<div class="pagination-box pagination-box-left">
						<div>
							<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
						</div>
					</div>
					<div class="pagination-box">
						<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
										[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
					</div>
					<div class="pagination-box pagination-box-right">
						<div class="d-flex align-items-center">
							<label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
							<select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="75">75</option>
								<option value="100">100</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
